exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.block[data-v-bbd4b414] {\n  margin-top: 20px;\n  text-align: right;\n}\n", ""]);

// exports
